export default __webpack_public_path__ + "static/media/mining.53813bd1.png";